export default __webpack_public_path__ + "static/DharmaGothicE_Regular_R-ddcca876b09254983e52f476d339a3e7.otf";